import React from 'react'
import { PageHeader } from 'antd';
import { Layout } from 'antd';
import logo from '../../Assests/assets/images/GLSR Logo_white/GLSR Logo_white.png';
import MainLayout from '../../Components/WebinarMainContent/MainLayout';
import "../../Components/WebinarHeader/Header.css";
const { Header, Footer, Content } = Layout;
const Webinar = (props)=>{
  return (
    <Layout>
      <Header className="webinar-page-header">
        <p class='webinar-img-container'>
          <img src={logo} class='webinar-header-img'/> 
        </p>
      </Header>
      <Content class="site-page-content">
        <MainLayout/>
      </Content>
      <Footer className='webinar-page-footer'></Footer>
    </Layout>
  )
}
export default Webinar; 
